import styled from '@emotion/styled';
import { ContainerPropTypes } from './types';

export const AvatarContainer = styled.div<ContainerPropTypes>`
  min-width: ${({ size }) => size.mobile}px;
  max-width: ${({ size }) => size.mobile}px;
  min-height: ${({ size }) => size.mobile}px;
  max-height: ${({ size }) => size.mobile}px;
  color: white;
  font-size: 20px;
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  overflow: hidden;

  @media (min-width: 640px) {
    min-height: ${({ size }) => `${size.desktop}px`};
    min-width: ${({ size }) => `${size.desktop}px`};
    max-height: ${({ size }) => `${size.desktop}px`};
    max-width: ${({ size }) => `${size.desktop}px`};
    font-size: ${({ fontSize }) => `${fontSize}px`};
  }
`;

export const DesktopImage = styled.div`
  display: none;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: 640px) {
    display: block;
  }
`;

export const MobileImage = styled.div`
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: 640px) {
    display: none;
  }
`;
